import { useEffect } from 'react';
import buildParamsStr from './buildParamsStr';
import { useHistory } from 'react-router-dom';

function usePersistSearchParams<T>(query?: T) {
  const history = useHistory();

  useEffect(() => {
    if (query) {
      history.replace({ search: buildParamsStr(query) });
    }
  }, [query]);
}

export default usePersistSearchParams;
